"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApolloProvider", {
  enumerable: true,
  get: function get() {
    return _reactApollo.ApolloProvider;
  }
});
Object.defineProperty(exports, "Query", {
  enumerable: true,
  get: function get() {
    return _reactApollo.Query;
  }
});
Object.defineProperty(exports, "Mutation", {
  enumerable: true,
  get: function get() {
    return _reactApollo.Mutation;
  }
});
Object.defineProperty(exports, "useQuery", {
  enumerable: true,
  get: function get() {
    return _reactApollo.useQuery;
  }
});
Object.defineProperty(exports, "useLazyQuery", {
  enumerable: true,
  get: function get() {
    return _reactApollo.useLazyQuery;
  }
});
Object.defineProperty(exports, "useMutation", {
  enumerable: true,
  get: function get() {
    return _reactApollo.useMutation;
  }
});
Object.defineProperty(exports, "useSubscription", {
  enumerable: true,
  get: function get() {
    return _reactApollo.useSubscription;
  }
});
Object.defineProperty(exports, "useApolloClient", {
  enumerable: true,
  get: function get() {
    return _reactApollo.useApolloClient;
  }
});
Object.defineProperty(exports, "gql", {
  enumerable: true,
  get: function get() {
    return _graphqlTag["default"];
  }
});
Object.defineProperty(exports, "createClient", {
  enumerable: true,
  get: function get() {
    return _apollo.createClient;
  }
});
Object.defineProperty(exports, "createAuthenticationMiddleware", {
  enumerable: true,
  get: function get() {
    return _apollo.createAuthenticationMiddleware;
  }
});
Object.defineProperty(exports, "createErrorMiddleware", {
  enumerable: true,
  get: function get() {
    return _apollo.createErrorMiddleware;
  }
});
Object.defineProperty(exports, "createGraphQLMiddleware", {
  enumerable: true,
  get: function get() {
    return _apollo.createGraphQLMiddleware;
  }
});
Object.defineProperty(exports, "createHeadersMiddleware", {
  enumerable: true,
  get: function get() {
    return _apollo.createHeadersMiddleware;
  }
});
Object.defineProperty(exports, "createRetryMiddleware", {
  enumerable: true,
  get: function get() {
    return _apollo.createRetryMiddleware;
  }
});

var _reactApollo = require("react-apollo");

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _apollo = require("./apollo");

// Libraries
// App
_graphqlTag["default"].query = "\n  __typename\n";
_graphqlTag["default"].errors = "\n  errors {\n    field\n    message\n  }\n";